import { salesRoute } from '@/modules/sales/route';
import { createRoute, redirect } from '@tanstack/react-router';

export const salesIndexRoute = createRoute({
  getParentRoute: () => salesRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({
      to: '/sales/charges',
    });
  },
});
